import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">漫画分类</h2>
          <p className="text-sm text-foreground-500 mt-2">按题材找到你最爱的韩国漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-xl p-6 hover:bg-accent-50 transition-all duration-200 cursor-pointer border border-background-200/70 hover:border-accent-200"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-xl`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{cat.name}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">{cat.description}</p>
              <span className="text-xs text-accent-600 font-medium">{cat.count} 部作品</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}